/* 筛选按钮<el-popover
  placement="bottom"
  width="300"
  v-model="popoverVisible">
  <el-checkbox-group v-model="propList">
    <el-checkbox :label="item" v-for="(item, index) in allPropList" :key="index" style="width: 120px">{{item.label}}</el-checkbox>
  </el-checkbox-group>
  <el-button slot="reference" size="small" style="float: right;">筛选</el-button>
</el-popover> */

/* 循环列<el-table-column
  :label="item.label"
  :prop="item.prop"
  :min-width="item.width"
  :sortable="item.sortable ? 'custom' : false"
  show-overflow-tooltip
  v-for="item in sortedPropList" :key="item.prop"
>
  <template slot-scope="scope">
    <template>
      {{scope.row[item.prop]}}
    </template>
  </template>
</el-table-column> */

// 导出
// const loading = this.$loading({
//   lock: true,
//   text: 'Loading',
//   spinner: 'el-icon-loading',
//   background: 'rgba(0, 0, 0, 0.7)'
// });
// let params = {
//   taskDTO: {
//     appCode: "ec-pc-api",
//     // 数据过滤
//     paramMap: {
//       exportTag: true,
//       ...this.searchForm.filterData
//     },
//     reportName: "skuExport"
//   },
//   // 配置导出列
//   columnDTOs: [
//     // {
//     //   columnName: '包件编码',
//     //   parentColumnName: null,
//     //   fieldName: 'packCode',
//     //   fieldType: 'string',
//     //   columnFormat: null
//     // }
//   ]
// };
// let labels = this.sortedPropList.map(v=>v.label);
// let props = this.sortedPropList.map(v=>v.prop);
// props.forEach((prop, index) => {
//   params.columnDTOs.push({
//     columnName: labels[index],
//     parentColumnName: null,
//     fieldName: prop,
//     fieldType: 'string',
//     columnFormat: null
//   })
// })
// // 不导出图片列
// params.columnDTOs = params.columnDTOs.filter(v=>v.columnName !== '图片');
// this.$q.common.customExportExcel({data: params}).then((res) => {
//   console.log(res)
//   loading.close();
//   this.$message({
//     type: "success",
//     message: "导出成功,请在导出列表中查看",
//   });
// });
export default {
  data() {
    return {
      propList: [] 
    }
  },
  computed: {
    allPropList() {
      let propsConf = [
        // 达成率
        [
          { label: '下限', prop: 'limitLower', width: '80px', sortable: 'custom', span: false, fixed: 'left', align:'right' },
          { label: '上限', prop: 'limitUpper', width: '80px', sortable: false, span: false, fixed: 'left', align:'left' },
          { label: '得分', prop: 'scoreBase', width: '80px', sortable: 'custom', span: false, fixed: 'left', align:'right' },
          { label: '超过下限', prop: 'limitExtra', width: '80px', sortable: 'custom', span: false, fixed: 'left', align:'right' },
          { label: '每1%加分', prop: 'addScoreOfProportion', width: '80px', sortable: 'custom', span: false, fixed: 'left', align:'right' },
          { label: '指标', prop: 'ruleDesc', width: '180px', sortable: 'custom', span: false, fixed: false, align:'right' },
          
        ],
        // 超卖率
        [
          { label: '下限', prop: 'limitLower', width: '80px', sortable: 'custom', span: false, fixed: 'left', align:'right' },
          { label: '上限', prop: 'limitUpper', width: '80px', sortable: false, span: false, fixed: 'left', align:'left' },
          { label: '得分', prop: 'scoreBase', width: '80px', sortable: 'custom', span: false, fixed: 'left', align:'right' },
          { label: '低于上限', prop: 'limitExtra', width: '110px', sortable: 'custom', span: false, fixed: 'left', align:'right' },
          { label: '额外加分', prop: 'scoreExtra', width: '110px', sortable: 'custom', span: false, fixed: 'left', align:'right' },
          { label: '高于上限', prop: 'limitExtraDel', width: '110px', sortable: 'custom', span: false, fixed: 'left', align:'right' },
          { label: '扣分', prop: 'scoreExtraDel', width: '80px', sortable: 'custom', span: false, fixed: 'left', align:'right' },
          { label: '指标', prop: 'ruleDesc', width: '150px', sortable: 'custom', span: false, fixed: false, align:'right' },
        ],
        // 超卖产品比例
        [
          { label: '下限', prop: 'limitLower', width: '80px', sortable: 'custom', span: false, fixed: 'left', align:'right' },
          { label: '上限', prop: 'limitUpper', width: '80px', sortable: false, span: false, fixed: 'left', align:'left' },
          { label: '得分', prop: 'scoreBase', width: '120px', sortable: 'custom', span: false, fixed: 'left', align:'right' },
          { label: '指标', prop: 'ruleDesc', width: '150px', sortable: 'custom', span: false, fixed: false, align:'right' },
          
        ],
        // 超卖产品数
        [
          { label: '下限', prop: 'limitLower', width: '80px', sortable: 'custom', span: false, fixed: 'left', align:'right' },
          { label: '上限', prop: 'limitUpper', width: '80px', sortable: false, span: false, fixed: 'left', align:'left' },
          { label: '超卖量占比', prop: 'proportion', width: '120px', sortable: 'custom', span: false, fixed: 'left', align:'right' },
          { label: '指标', prop: 'ruleDesc', width: '150px', sortable: 'custom', span: false, fixed: false, align:'right' },
        ],
        //积压产品比例
        [
          { label: '下限', prop: 'limitLower', width: '80px', sortable: 'custom', span: false, fixed: 'left', align:'right' },
          { label: '上限', prop: 'limitUpper', width: '80px', sortable: false, span: false, fixed: 'left', align:'left' },
          { label: '得分', prop: 'scoreBase', width: '120px', sortable: 'custom', span: false, fixed: 'left', align:'right' },
          { label: '指标', prop: 'ruleDesc', width: '150px', sortable: 'custom', span: false, fixed: false, align:'right' },
        ],
        //积压产品数
        [
          { label: '下限', prop: 'limitLower', width: '80px', sortable: 'custom', span: false, fixed: 'left', align:'right' },
          { label: '上限', prop: 'limitUpper', width: '80px', sortable: false, span: false, fixed: 'left', align:'left' },
          { label: '积压率占比', prop: 'proportion', width: '120px', sortable: 'custom', span: false, fixed: 'left', align:'right' },
          { label: '指标', prop: 'ruleDesc', width: '150px', sortable: 'custom', span: false, fixed: false, align:'right' },
        ],
      ]
      return propsConf;
    },

  },
  mounted() {
    this.propList = this.allPropList
  },
  methods: {
   
  }
}